const LINKS = [
  { id: "invitation", label: "Invitation" },
  { id: "itinerary", label: "Itinerary" },
  { id: "logistics", label: "Logistics" },
  { id: "guests", label: "Guests" },
  { id: "gallery", label: "Gallery" },
  { id: "share", label: "Share" },
];

const scrollTo = (id) => (e) => {
  e.preventDefault();
  if (window.__lenis) {
    window.__lenis.scrollTo(`#${id}`, { offset: -72 });
  } else {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  }
};

export default function Navbar() {
  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 inset-x-0 z-50 bg-[#FDFBF7]/80 backdrop-blur-xl border-b border-[#D4AF37]/30"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-[72px] flex items-center justify-between">
        <a
          href="#top"
          onClick={scrollTo("top")}
          data-testid="nav-logo"
          className="font-serif text-2xl tracking-tight text-[#5D171E]"
        >
          V <span className="italic text-[#D4AF37]">&</span> P
        </a>
        <nav className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              onClick={scrollTo(l.id)}
              data-testid={`nav-link-${l.id}`}
              className="text-xs uppercase tracking-[0.2em] text-[#1A1A1A]/70 hover:text-[#5D171E] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <a
          href="#rsvp"
          onClick={scrollTo("rsvp")}
          data-testid="nav-rsvp-button"
          className="rounded-full bg-[#5D171E] text-[#FDFBF7] text-xs uppercase tracking-[0.2em] px-6 py-3 hover:bg-[#471016] transition-colors duration-300"
        >
          RSVP
        </a>
      </div>
    </header>
  );
}
